export const MASK_ZINDEX = '1500';
export const DRAWER_MASK_ZINDEX = '1500';
export const DRAWER_ZINDEX = '1550';
export const POPUP_ZINDEX = '1450';
export const DIALOG_MASK_ZINDEX = '1600';
export const DIALOG_ZINDEX = '1625';
export const GRID_DATA_LOADER_ZINDEX = '1500';
